import { useAdminMode } from "@/hooks/useAdminMode";
import { cn } from "@/lib/utils";
import { LayoutDashboard, Shield } from "lucide-react";

export function AdminModeToggle() {
  const { isAdminMode, toggleMode, canAccessAdminMode } = useAdminMode();

  if (!canAccessAdminMode) return null;

  return (
    <div className="flex items-center gap-1 rounded-lg border border-border bg-muted/50 p-1">
      <button
        onClick={() => !isAdminMode || toggleMode()}
        className={cn(
          "flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium transition-all",
          !isAdminMode
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        )}
      >
        <LayoutDashboard className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">My Business</span>
      </button>
      <button
        onClick={() => isAdminMode || toggleMode()}
        className={cn(
          "flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium transition-all",
          isAdminMode
            ? "bg-primary text-primary-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        )}
      >
        <Shield className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">Settings</span>
      </button>
    </div>
  );
}
